import React, { useState, useEffect } from "react";
import { FaUserCircle, FaBars } from "react-icons/fa";
import { useAdminAuth } from "../../context/AdminAuthContext";
import "./Navbar.css";
import { Logo } from "../../images/ImageData";
import { LogoIcon } from "../../images/ImageData";

const Navbar = () => {
  const { toggleSidebar, adminName, logout } = useAdminAuth();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [avatar, setAvatar] = useState("");

  // Load avatar from local storage
  useEffect(() => {
    const storedAvatar = localStorage.getItem("avatar");
    if (storedAvatar) {
      setAvatar(storedAvatar);
    }
  }, []);

  const handleModalToggle = () => setIsModalOpen(!isModalOpen);

  const handleAvatarChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const imageData = reader.result;
        setAvatar(imageData); 
        localStorage.setItem("avatar", imageData); 
      };
      reader.readAsDataURL(file);
    }
  };

  return (
    <>
      <div className="navbar">
        <div className="navbar-sub-container">
          {" "}
          <button className="toggle-sidebar" onClick={toggleSidebar}>
            <FaBars size={20} />
          </button>
          <div className="navbar-logo-admin-icon">
            <img src={LogoIcon} alt="logo" />
          </div>
        </div>

        <div className="navbar-logo-admin">
          <img src={Logo} alt="logo" />
        </div>

        <div className="navbar-right">
          <FaUserCircle
            size={25}
            className="icon"
            onClick={handleModalToggle}
          />
          <button type="button" className="logout-button" onClick={logout}>
            Logout
          </button>
        </div>
      </div>

      {/* Modal */}
      {isModalOpen && (
        <div className="navbar-modal-overlay" onClick={handleModalToggle}>
          <div
            className="navbar-modal"
            onClick={(e) => e.stopPropagation()} // Prevent closing modal when clicking inside
          >
            <button className="navbar-modal-close" onClick={handleModalToggle}>
              &times;
            </button>
            <div className="navbar-modal-content">
              <img
                src={
                  avatar ||
                  "https://w7.pngwing.com/pngs/205/731/png-transparent-default-avatar-thumbnail.png"
                }
                alt="User Avatar"
                className="user-image"
              />
              <h3>{adminName || "Admin"}</h3>
              <input
                type="file"
                accept="image/*"
                className="upload-input"
                onChange={handleAvatarChange}
              />
              <a href="/password-reset" className="reset-password-link">
                Reset Password
              </a>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
